import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent {

  @Input() title: string = '';
  @Input() message: string = '';
  @Input() messageAction: string = '';
  @Input() actionIcon: string = '';
  @Input() type: undefined | 'success' | 'info' | 'error' = 'success';
  @Output() actionClicked: EventEmitter<any> = new EventEmitter();

  constructor() {}

  emitAction() {
    this.actionClicked.emit();
  }
}
